/**
 * Promotional images for the reserve page, on how to use G2MM
 */
define('setup/reserve-g2mm/promo-steps/promo-steps',['require','knockout','lib/gotomeetme/get-steps-image-url'],function (require) {
    var ko = require('knockout');
    var getStepsImageUrl = require('lib/gotomeetme/get-steps-image-url');

    return function () {
        var self = this;

        self.activate = function (activationData) {
            self.stepsShareImageUrl = ko.observable(getStepsImageUrl('setup-share-small'));
            self.stepsMeetImageUrl = ko.observable(getStepsImageUrl('setup-meet-small'));
            self.isG2MMSchedulingTest = activationData.isG2MMSchedulingTest;
        };
    };
});

